import React from "react";
import { OccurrenceFrequencyLevel } from "./dates/occurrence_frequency";
import {
  UserShape,
  GoalConstructorShape,
  OccurrenceFrequencyShape,
} from "../interfaces/classTypes";

let includedeGoals = [];
export class GoalTemplate {
  public continuous: boolean;
  public createdAtFormatted: string;
  public description: string;
  public hasErrors: boolean;
  public id: number | null;
  public leaderboardEnabled: boolean;
  public occurrenceAmount: number | null;
  public occurrenceFrequency: OccurrenceFrequencyShape | null;
  public name: string;
  public user: UserShape;

  constructor(data: GoalConstructorShape) {
    this.hasErrors = data.hasErrors;
    this.user = data.user;
    this.id = data.id;
    this.leaderboardEnabled = data.leaderboardEnabled;
    this.description = data.description;
    this.occurrenceAmount = data.occurrenceAmount;
    this.continuous = data.continuous;
    this.createdAtFormatted = data.createdAtFormatted;
    this.name = data.name;
    typeof data.occurrenceFrequency == "string"
      ? this.setOccurrenceFrequency(data.occurrenceFrequency)
      : (this.occurrenceFrequency = data.occurrenceFrequency);
    this.save();
  }

  save() {
    includedeGoals.push(this);
  }

  setOccurrenceFrequency(goalFrequency) {
    if (typeof goalFrequency == "string") {
      this.occurrenceFrequency = OccurrenceFrequencyLevel.includedOccurrenceFrequencies().find(
        (frequency) => frequency.name == goalFrequency
      );
    } else {
    }
  }

  static includedGoals() {
    return includedeGoals;
  }

  static findById(input) {
    return includedeGoals.find((goal) => goal.id == input);
  }
}
